import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { from } from '@guardian/source/foundations';
const mobileSvg = css `
	position: absolute;
	top: 0;
	min-height: 100%;
	display: inline;
	width: 100%;

	${from.mobileLandscape} {
		display: none;
	}
`;
export default function SvgSquaresHeroMobile() {
    return (_jsx("svg", { className: "svg-squares-hero-mobile", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 375 321", preserveAspectRatio: "xMinYMid slice", css: mobileSvg, children: _jsxs("g", { fill: "none", fillRule: "evenodd", children: [_jsx("path", { d: "M396 241h-87v87h87z", fill: "#5CC9F8" }), _jsx("path", { d: "M353 203h-87v87h87z", fill: "#2EBDFB" }), _jsx("path", { d: "M310 170h-87v87h87z", fill: "#00B2FF" }), _jsxs("g", { fill: "#FF7F0F", children: [_jsx("path", { d: "M119 146H32v87h87z" }), _jsx("path", { d: "M62 206h-87v87h87z", opacity: ".6" })] }), _jsx("path", { d: "M343 87h87V0h-87z", fill: "#D33F92" }), _jsx("path", { d: "M293 117h87V30h-87z", fill: "#CE147C" })] }) }));
}
